export const EMPTY = "—";

const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const num = new Intl.NumberFormat("en-US");
const compact = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });

export const formatMoney = (cents: number | null | undefined) => (cents === null || cents === undefined ? EMPTY : usd.format(cents / 100));
export const formatNumber = (n: number | null | undefined) => (n === null || n === undefined ? EMPTY : num.format(n));
export const formatCompact = (n: number | null | undefined) => (n === null || n === undefined ? EMPTY : compact.format(n));
/** Already-a-percentage number (0–100) → "12.5%". */
export const formatPercent = (n: number | null | undefined, digits = 1) => (n === null || n === undefined ? EMPTY : `${n.toFixed(digits)}%`);

export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return EMPTY;
  if (ms < 1000) return `${Math.round(ms)} ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(ms < 10_000 ? 1 : 0)} s`;
  const m = Math.floor(ms / 60_000);
  const s = Math.round((ms % 60_000) / 1000);
  return `${m}m ${s}s`;
}

/** Short form of a long id for dense cells; the full id is always available on hover/copy. */
export const shortId = (id: string | null | undefined, n = 8) => (id ? (id.length > n + 1 ? `…${id.slice(-n)}` : id) : EMPTY);

export const humanize = (s: string | null | undefined) =>
  s
    ? s
        .replaceAll("_", " ")
        .replaceAll(".", " · ")
        .toLowerCase()
        .replace(/^\w/, (c) => c.toUpperCase())
    : EMPTY;

export function formatPhone(e164: string | null | undefined) {
  if (!e164) return EMPTY;
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
